<script>
    import { truncateString } from "../../js/utils";

    let { value, rowIndex, rowId, instructKey } = $props();

    let data = $derived(value);

    let targetUrl = $derived.by(() => {
        if (!data || !data.name || !data.kind || !data.value) return "#";

        const type = data.target_object_type || "asset";

        const path = `/property/${type}/${encodeURIComponent(data.kind)}/${encodeURIComponent(data.name)}/values`;

        const queryParams = {
            value: data.value,
            ...(data.filters || {})
        };

        const queryStr = new URLSearchParams(queryParams).toString();
        return `${path}?${queryStr}`;
    });
</script>

{#if data}
    {#if data.value}
        <a
            href={targetUrl}
            title={data.value}
        >
            {truncateString(data.value, data.max_chars ? data.max_chars : 70)}
        </a>
    {:else}
        <span>N/A</span>
    {/if}
{/if}

<style>
</style>